import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import selectAllProps from './selectors';
import NewProjectForm from '../../components/ProjectManager/NewProjectForm';
import * as actions from './actions';
import * as projectActions from '../../actions/projectAction';
import Validator from 'validatorjs';

class NewProjectContainer extends React.Component {

    componentWillMount(){
        if(this.props.projectStates.length==0) this.props.projectActions.getProjectStates();
    }

    storeProject(data) {
        this.props.actions.storeProject(data).then((project) => {
            this.context.router.push('/project');
        });
    }

    validate(data) {
        let errors = {};
        const rules = {
            name: 'required',
            state: 'required'
        };
        const messages = {
            required: 'Ce champ est obligatoire.'
        };
        let validator = new Validator(data, rules, messages);
        if (validator.fails()) {
            errors = validator.errors.all();
        }
        return errors;
    }

    render() {
        const validate = this.validate.bind(this);
        const storeProject = this.storeProject.bind(this);
        return (
            <NewProjectForm projectStates={this.props.projectStates} errors={this.props.errors} validate={validate} onSubmit={storeProject}/>
        );
    }
}

NewProjectContainer.propTypes = {
    projects: PropTypes.array.isRequired,
    projectActions: PropTypes.object,
    actions: PropTypes.object,
    errors: PropTypes.object,
    projectStates: PropTypes.array
};

NewProjectContainer.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return selectAllProps(state);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        projectActions: bindActionCreators(projectActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewProjectContainer);


/** WEBPACK FOOTER **
 ** ./src/container/ProjectContainer/NewProjectContainer.js
 **/